import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('../status/status.routes').then(m => m.STATUS_ROUTES)
  },
  /* No matching routes */
  {
    path: '**',
    redirectTo: ''
  }
];
